import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor } from '@angular/common/http';
import { AuthUtilService } from './auth-util.service';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {

  constructor(private _injector: Injector) { }

  intercept(req, next){
    let tokenizedReq = req.clone({
      // setHeaders: {
        // Authorization: `Bearer ${this._injector.get(AuthUtilService).getToken()}`,
      // },
      withCredentials : true
    })
    return next.handle(tokenizedReq)
    // return next.handle(req)
  }
}
